import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import { ALL_ITEM_DISPLAY } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function JewelryDisplayPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_DISPLAY[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Luxury Jewelry Display Manufacturer & Supplier | Lussopack</title>
        <meta name="description" content="Check out our wide range of jewelry display showcases, including jewelry display stands, storage boxes, and more. Our displays make every piece a masterpiece." />
        <meta name="keywords" content="jewelry display manufacturer" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/jewelry-displays/" />               
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Jewelry Display"}
      />        
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default JewelryDisplayPage;
